import React from "react";

const Bold = ({ customComponent, onChange, isActive, isDisabled }) => {
	const toggleBold = () => {
		if (onChange) onChange();
	};

	return (
		<>
			<button
				className={`editor-menu-item${isActive ? " is-active" : ""}`}
				onClick={toggleBold}
				title="Bold"
				type="button"
				disabled={isDisabled}>
				{customComponent ? customComponent : <i className="fas fa-bold" />}
			</button>
		</>
	);
};

export default Bold;
